let navigator = null;

export function setNavigator(navigateFn) {
  navigator = navigateFn;
}

export function navigate(path, options = {}) {
  if (navigator) {
    navigator(path, options);
  } else {
    console.warn("Navigator not initialized");
  }
}
